/**
 * Header Factory
 */
 (function () {

    'use strict';

    angular.module('itxApp.common').factory('ItxHeaderFct', ItxHeaderFct);

    ItxHeaderFct.$inject = [
        'ItxScreenSizeSvc',
        'imAccessService',
        'imPopupService',
        'imHeaderEventService',
        'imSearchService',
        'imDispatcherService',
        'ItxConfigurationSvc',
        'DUTTI_CONS',
        'ItxUtilsFct',
        'crmService',
        '$q',
        'AkamaiDateSvc',
        'CmsConfigSvc',
        'ItxLoginSvc',
        'ngDialog',
        'ItxShopCartFct',
        '$rootScope',
        'CommonServices',
        'CmsPageService',
        'NavigationService'
    ];

    /**
     * Header factory helper
     * @constructor
     */
    function ItxHeaderFct(
        ItxScreenSizeSvc, 
        imAccessService, 
        imPopupService, 
        imHeaderEventService,
        imSearchService,
        imDispatcherService, 
        ItxConfigurationSvc,
        DUTTI_CONS,
        ItxUtilsFct,
        crmService,
        $q,
        AkamaiDateSvc,
        CmsConfigSvc,
        ItxLoginSvc,
        ngDialog,
        ItxShopCartFct,
        $rootScope,
        CommonServices,
        CmsPageService,
        NavigationService
    ) {
        
        var _this = this;
        var scrollTop = 0;
        
        _setStyleTheme();

        _this.hasInitialized = false;

        var loginPromise;

        var service = {
            // UI
            isVisibleLogin: false,
            isVisibleMiniCart: false,
            toggleLogin: toggleLogin,
            toggleMiniCart: function (forceClose) {
                if (ItxScreenSizeSvc.is('xs,sm') && !forceClose) {
                    window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
                    imHeaderEventService.createEvent('cart');
                } else {
                    if (_this.miniCartOpen || forceClose) {
                        _removeNoScroll();
                        _hideMiniCart();
                        imDispatcherService.sortEvent('pageview', null, null, 'minicart');
                    } else {
                        _showMiniCart();
                    }
                }
            },
            toggleWishlist: function () {},
            toggleSearch: function () {},
            toggleMenuMobile: function () {},
            hideAllElementsUi: hideAllElementsUi,
            showMiniCart: _showMiniCart,
            getIsVisibleLogin: getIsVisibleLogin,
            getIsVisibleMiniCart: getIsVisibleMiniCart,
            loadEmpathyX: function () {},
            initEmpathyX: function () {},
            // CONF
            checkCrespon: function () {},
            setLastSection: _setLastSection,
            getLastSection: _getLastSection,
            imTriggerAnalyticEvent: _imTriggerAnalyticEvent,
            isHeaderCms: function () {},
            // STYLES 
            setStyle: _setStyle,
            setStyleTheme: _setStyleTheme,
            desfilePeriodConfig: _desfilePeriodConfig,
            setPageVisited: _setPageVisited,
            loadGoogleOptimize: _loadGoogleOptimize,
            isLogged: isLogged,
            toggleMyOrders: toggleMyOrders,
            signIn: signIn,
            showRegister: _showRegister,
            setHeightHeaderCms: function () {},
            getheightrenderidt: function () {},
            addListenerApollo: _addListenerApollo
        };
        
        ItxUtilsFct.isHighlightsEnabled().then((highlightsEnabled) => {
            if(!ItxConfigurationSvc.isBgEnable() && !highlightsEnabled){
                $('body').addClass('not-BG');
            }
        });
        
        return service;

        function getIsVisibleLogin() {
            return _this.isVisibleLogin;
        }
        function getIsVisibleMiniCart() {
            return _this.isVisibleMiniCart;
        }

        function hideAllElementsUi() {
            _hideLogin();
            _removeNoScroll();
        }
        // UI Service
        function toggleLogin(forceClose) {
            if (_this.isVisibleLogin || forceClose) {
                _hideLogin();
                _removeNoScroll();
            } else {
                _showLogin();
                _addNoScroll();
            }
        }


        function _desfilePeriodConfig() {
            var deferred = $q.defer();
            var response = {
                isVipPeriod: false, 
                categoryIds: ''
            }
            const tz = ItxUtilsFct.getTimeZone();
            
            $q.all({
                date: AkamaiDateSvc.getLocalDate(tz),
                info: CmsConfigSvc.getProperty('advanced_sales_info'),
                is360: crmService.is360AllCountries()
             })
             .then(function(obj){
                // debugger
                if(!obj.info || !obj.date){       
                    console.error('Invalid params provided ');
                    deferred.resolve(response);
                    return;
                }
                var init = obj.info.from_no_vip;
                if(obj.is360){
                    init = obj.info.from_vip;
                } 
                var initDate = moment.tz(init, 'YYYY-MM-DD HH:mm:ss' , tz);
                
                var currentDate = obj.date;

                response.isVipPeriod = currentDate.isSameOrAfter(initDate);

                if(obj.info.category_ids.length){
                    response.categoryIds = obj.info.category_ids.join(',')
                }
                deferred.resolve(response);
            })
            .catch(function(err){
                deferred.resolve(response);
            });

            return deferred.promise;
        }

        function isLogged() {
            return ItxLoginSvc.isLogged();
        }

        function toggleMyOrders() {
            inditex.getXconfiguracionValue('ENABLE_GUEST_TRACKING_BY_SMS', function (status, value) {
                var location;
                if (joyr.user.utils.isAuthenticated()) {
                    location = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false);
                    window.location.href = location + '#/orders-type/';
                } else {
                    location = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false);
                    window.location.href = location + '#/login';
                    //ItxLoginSvc.signIn();
                }
            });// fin  inditex.getXconfiguracionValue('ENABLE_GUEST_TRACKING_BY_SMS'
        }

                /**
        * @ngdoc method
        * @name signIn
        * @param forceModal (Optional) to force opening sign in form dialog
        * @methodOf  common.service:ItxLoginSvc
        * @description
        *
        * Open login dialog
        * 
        * @returns {promise} loginPromise - Login Promise
        */
        function signIn(forceModal, preselectedFields, returnId = undefined) {
            if ((ItxScreenSizeSvc.is('xs,sm') || forceModal) && !isLogged()) {
                ngDialog.open({
                    template: 'user-access-dialog-wrapper.tpl',
                    className: 'new-modal ma-modal-md ma-modal-macro ma-login-modal ngdialog-theme-plain ',
                    showClose: true,
                    bindToController: true,
                    data: { preselectedFields },
                    preCloseCallback: function () {
                        if (returnId !== undefined) {
                            location.reload();
                        }
                    }
                });
                // IMAnalytics Login para pantallas pequenas
                imAccessService.createView('acceso', 'login');
            } else {
                toggleLogin();
            }
            loginPromise = $q.defer();

            return loginPromise.promise;
        }

        function _showRegister() {
            if (!isLogged()) {
                ngDialog.open({
                    template: 'user-register-mgm-dialog-wrapper.tpl',
                    className: 'new-modal ma-modal-md ma-modal-macro register-modal ngdialog-theme-plain ma-login-modal ngDialog-mgm',
                    showClose: true,
                    bindToController: true,
                    data: {
                        action: 'register',
                        options: {
                            hideLogin: true,
                            feelRequired: false,
                            newsletterRequired: false
                        },
                        onRegister: function () {
                            window.location.href =
                                joyr.utils.getCommonPageUrl('ItxHomePage', false, false) + 'my-account/sponsorship/welcome-sponsored';
                        }
                    },
                    preCloseCallback: function () {
                        imDispatcherService.sortEvent('pageview', null, null, 'login');
                    }
                });

                /**
                 * IMAnalyics IMAnalyics  Perfil usuario - Acceso Registro
                 */
                imAccessService.triggerView('register');
            } else {
                toggleLogin();
            }
        }

        function _setLastSection(section){
            if(_validateSections(section)){
                inditex.setLocalStorage('LAST_SECTION', section);
                _addClassSection(section);

                if(_this.searchWrapperActive){
                    imDispatcherService.sortEvent('pageview', null, null, 'search');
                    _loadSectionEmpathy(section);
                } else {
                    _loadSectionEmpathy(section);
                }
                
            }
        }

        function _getLastSection(){
            var section = inditex.getLocalStorage('LAST_SECTION');
            if(!_validateSections(section)){
                section = 'WOMEN';
                _setLastSection(section);
            }
            _addClassSection(section);
            return section;
        }

        function _loadSectionEmpathy(section){
            if(_this.hasInitialized){
                EmpathyX.setConfig({section: section});
            }
        }

        function _imTriggerAnalyticEvent(headerIcon) {
            imHeaderEventService.createEvent(headerIcon);
        }

        // ADD STYLES CONFIGURED
        function _setStyle(type) {
            switch (type) {
                case 'dark':
                    $('body').removeClass('dark-theme');
                    $('body').addClass('light-theme');
                    break;
                case 'light':
                    $('body').removeClass('light-theme');
                    $('body').addClass('dark-theme');
                    break;
            }
        }

        /**
         * Función para añadir estilos al body en función de la página y configuración de CMS
         */
        function _setStyleTheme() {
            CmsConfigSvc.getConfigCmsPage().then(function(conf){
                _setStyleHeader(conf);
            }).catch(function(){
                _setStyleHeader(conf);
            });
        }

        /**
         * Función para añadir estilos a la cabecera
         */
        function _setStyleHeader(theme) {
            var headerTheme;
            // VALOR POR DEFECTO
            if(!theme){
                theme = {};
            } 
            if(!theme.header){
                if(!CmsConfigSvc.isCmsPage()){
                    theme.header = {
                        "mobile": "compact",
                        "desktop": "compact",
                        "style": "light"
                    };
                } else {
                    theme.header = {
                        "mobile": "ghost",
                        "desktop": "ghost",
                        "style": "dark"
                    };
                }
            }

            if(ItxScreenSizeSvc.isMobile()){
                headerTheme = theme.header.mobile;
            } else {
                headerTheme = theme.header.desktop;
            }
            
            if(headerTheme === 'ghost'){
                _setStyle(theme.header.style);
                $('body').removeClass('compact-mode');
                $('body').addClass('ghost-mode');
            } else {
                $('body').removeClass('ghost-mode');
                $('body').addClass('compact-mode');
            }
        }


        function _setScrollTop(scrollToElement) {
            var Ipad = $('html').hasClass('ipad');
            if (Ipad) {
                if(scrollToElement){
                    $(window).scrollTop(scrollTop);
                    scrollTop = 0;
                } else {
                    scrollTop = $(window).scrollTop();
                }
            }
        }

        function _showLogin() {
            if (joyr.user.utils.isAuthenticated()) {
                NavigationService.goToMyAccountPage('menu');
            } else {
                _this.isVisibleLogin = true;
            }
        }
        function _hideLogin() {
            _this.isVisibleLogin = false;
        }
        function _hideMiniCart() {
            $('.aside-wrap.mini-shopcart').removeClass('open');
            _this.miniCartOpen = false;
        }
        function _showMiniCart () {
            $('.aside-wrap.mini-shopcart').addClass('open');
            _this.isVisibleMiniCart = true;
            _this.miniCartOpen = true;
            
            // IMAnalytics lanzamos pageview
            var label = angular.element('#shopcart-btn > .header-count').children().length > 0 ? 'lista_de_productos' : 'vacia';
            imPopupService.sendBasic('checkout','minicesta',label);
            _hideLogin();
            _addNoScroll();
        }

        function _addNoScroll() {
            $('html').addClass('no-scroll');
            _setScrollTop();
        }

        function _removeNoScroll() {
            $('html').removeClass('no-scroll');
            _setScrollTop(true);
        }
        
        function initEmpathyX() {}
        function loadEmpathyX() {}

        function _validateSections(section) {
            var isValidSection;
            if(section === 'MEN' || section === 'BG' || section === 'WOMEN'){
                isValidSection = true;
            } else {
                isValidSection = false;
            }
            return isValidSection;
        }

        function _addClassSection(section) {
            
            $('body').removeClass('is-MEN is-WOMEN is-BG');
            
            $('body').addClass('is-' + section);
        }

        function _setPageVisited() {
            const cookieGroup = DUTTI_CONS.COOKIE_GROUPS.FUNCTIONAL_PERSONALIZATION;
            const isCookieGroupAllowed = CommonServices.isCookieGroupAllowed(cookieGroup);
            if(isCookieGroupAllowed){
                if(!inditex.getSessionStorage('user_pages_visited')){
                    inditex.setSessionStorage('user_pages_visited', 1);
                } else {
                    var times = parseInt(inditex.getSessionStorage('user_pages_visited')) + 1; 
                    inditex.setSessionStorage('user_pages_visited', times);
                }
            }
        }

        function _loadGoogleOptimize(){	
            try {	
                var ga = document.createElement('script');	
                ga.type = 'text/javascript';	
                ga.src = 'https://www.googleoptimize.com/optimize.js?id=OPT-MVT6Q6P';	
                document.getElementsByTagName("head")[0].appendChild(ga);	
            } catch (error) {	

            }	
        }

        function _addListenerApollo(){
            document.addEventListener('legacy-event', function(event){
                console.log('LEGACY EVENT CALL - DEPRECATED -');
                if (event && event.detail && event.detail.extra && event.detail.extra.type) {
                    CmsPageService.handleClick(event.detail.extra);
                }
            });
        }

    }

})();
   